export default {
    name: 'bill-log-mail-result',
    mixins: [],
    extends: {},
    components: {},
    props: ['Msg'],
    data() {
        return {};
    },
    computed: {

    },
    watch: {},
    created() {

    },
    mounted() {},
    updated() {},
    beforeDestroy() {},
    methods: {

    },
};


// WEBPACK FOOTER //
// ./src/components/billLog/billLogMailResult.js